import React from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
const OrganizationDetails = ({ form, handleChange, handleNumberChange, handlePhoneNumberChange, handleEmailChange, errors,
  handleLetterChange, handleNullableChange,handleEnumChange }) => {
  const { t } = useTranslation();
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('personalInformation.departmentExplanation')}
    </Tooltip>
  );
  return (
    <>
      <h3 className='border-h3'>
        {t('personalInformation.organizationSec')}
      </h3>
      <p className='mark-message'>{t('header.mandatory')}</p>
      <Form.Group controlId="formMediaType" className="mt-3">
        <Form.Label>{t('emailVerification.mediaType')} *</Form.Label>
        <Form.Control className="form-select"
          as="select"
          value={form.mediaType}
          name="mediaType"
          onChange={handleEnumChange}
        >
          <option value="">{t("choose")}</option>
          <option value='TV'>{t('emailVerification.mediaTypes.TV')}</option>
          <option value='RADIO'>{t('emailVerification.mediaTypes.RADIO')}</option>
          <option value='AGENCY'>{t('emailVerification.mediaTypes.AGENCY')}</option>
          <option value='PUBLICATION'>{t('emailVerification.mediaTypes.PUBLICATION')}</option>
          <option value='WEBSITE'>{t('emailVerification.mediaTypes.WEBSITE')}</option>
          <option value='NEWSPAPER'>{t('emailVerification.mediaTypes.NEWSPAPER')}</option>
          <option value='MAGAZINE'>{t('emailVerification.mediaTypes.MAGAZINE')}</option>
          <option value='PHOTO_AGENCY'>{t('emailVerification.mediaTypes.PHOTO_AGENCY')}</option>
          <option value='NEWS_AGENCY'>{t('emailVerification.mediaTypes.NEWS_AGENCY')}</option>
          <option value='ONLINE_MEDIA'>{t('emailVerification.mediaTypes.ONLINE_MEDIA')}</option>
          <option value='OTHER'>{t('emailVerification.mediaTypes.OTHER')}</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          {t('validation.field')}
        </Form.Control.Feedback>
      </Form.Group>
      {form.mediaType === "OTHER" && (
        <Form.Group controlId="formMediaTypeDescription" className="mt-3">
          <Form.Label>{t("personalInformation.mediaTypeDescription")} *</Form.Label>
          <Form.Control
            type="text"
            name="mediaTypeDescription"
            value={form.mediaTypeDescription}
            onChange={handleChange}
            required
          />
        </Form.Group>
      )}

      <Form.Group controlId="formOrganization" className="mt-3">
        <Form.Label>{t("personalInformation.organization")} *</Form.Label>
        <Form.Control
          type="text"
          name="organization.organization"
          value={form.organization.organization}
          onChange={handleLetterChange}
          isInvalid={!!errors.organization}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formDepartment" className="mt-3">
        <Form.Label>
          {t("personalInformation.department")} *
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <span style={{ cursor: 'pointer', marginLeft: '5px' }}>[?]</span>
          </OverlayTrigger>
        </Form.Label>
        <Form.Control
          type="text"
          name="organization.department"
          value={form.organization.department}
          onChange={handleLetterChange}
          isInvalid={!!errors.organizationDepartment}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formJobTitle" className="mt-3">
        <Form.Label>{t("personalInformation.jobTitle")} *</Form.Label>
        <Form.Control
          type="text"
          name="organization.jobTitle"
          value={form.organization.jobTitle}
          onChange={handleLetterChange}
          isInvalid={!!errors.jobTitle}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyAddress" className="mt-3">
        <Form.Label>{t("personalInformation.companyAddress")} *</Form.Label>
        <Form.Control
          type="text"
          name="organization.address"
          value={form.organization.address}
          onChange={handleLetterChange}
          isInvalid={!!errors.organizationAddress}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCity" className="mt-3">
        <Form.Label>{t("personalInformation.city")} *</Form.Label>
        <Form.Control
          type="text"
          name="organization.city"
          value={form.organization.city}
          onChange={handleLetterChange}
          isInvalid={!!errors.organizationCity}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formPostalCode" className="mt-3">
        <Form.Label>{t("personalInformation.postalCode")} *</Form.Label>
        <Form.Control
          type="text"
          name="organization.postalCode"
          value={form.organization.postalCode}
          onChange={handleLetterChange}
          isInvalid={!!errors.organizationPostalCode}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyPhone1" className="mt-3">
        <Form.Label>{t("personalInformation.companyPhone1")} *</Form.Label>
        <div className={`input-group ${!!errors.mobile ? 'is-invalid-custom' : ''}`}>
          <PhoneInput
            country={'az'} // Set a default country
            value={form.organization.phone1}
            onChange={(phone) => handlePhoneNumberChange('organization.phone1', phone)}
            inputProps={{
              name: 'organization.phone1',
              required: true,
            }}
          />
          {!!errors.phone1 && (
            <div className="invalid-feedback-custom ">
              {t("validation.field")}
            </div>
          )}
          <Form.Control.Feedback type="invalid">
            {t("validation.field")}
          </Form.Control.Feedback>
        </div>
      </Form.Group>

      <Form.Group controlId="formCompanyPhone2" className="mt-3">
        <Form.Label>{t("personalInformation.companyPhone2")}</Form.Label>
        <PhoneInput
          country={'az'} // Set a default country
          value={form.organization.phone2}
          onChange={(phone) => handlePhoneNumberChange('organization.phone2', phone)}
          inputProps={{
            name: 'organization.phone2',
            required: true,
          }}
          isInvalid={!!errors.phone2} // Error handling if needed
        />

      </Form.Group>

      <Form.Group controlId="formCompanyMobile" className="mt-3">
        <Form.Label>{t("personalInformation.companyMobile")}</Form.Label>

        <PhoneInput
          country={'az'}
          value={form.organization.mobile}
          onChange={(phone) => handlePhoneNumberChange('organization.mobile', phone)}
          inputProps={{
            name: 'organization.mobile',
            required: true,
          }}
          isInvalid={!!errors.mobile}
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formCompanyEmail" className="mt-3">
        <Form.Label>{t("personalInformation.companyEmail")} *</Form.Label>
        <Form.Control
          type="email"
          name="organization.email"
          value={form.organization.email}
          onChange={handleEmailChange}
          isInvalid={!!errors.organizationEmail}
          required
        />
        <Form.Control.Feedback type="invalid">
          {t("validation.organizationEmail")}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formMediaEquipment" className="mt-3">
        <Form.Label>{t("personalInformation.mediaEquipment")} *</Form.Label>
        <Form.Control className="form-select"
          as="select"
          name="organization.mediaEquipment"
          value={form.organization.mediaEquipment}
          onChange={handleLetterChange}
          isInvalid={!!errors.organizationMediaEquipment}
          required
        >
          <option value="">{t("choose")}</option>
          <option value={true}>{t("yes")}</option>
          <option value={false}>{t("no")}</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          {t("validation.field")}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Media Type Specific Fields */}
      {form.mediaType === "WEBSITE" && (
        <>
          <Form.Group controlId="formWebsiteAddress" className="mt-3">
            <Form.Label>{t("personalInformation.websiteAddress")} *</Form.Label>
            <Form.Control
              type="text"
              name="organizationType.address"
              value={form.organizationType.address}
              onChange={handleChange}
              isInvalid={!!errors.websiteAddress}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("validation.field")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formWebVisitors" className="mt-3">
            <Form.Label>{t("personalInformation.webVisitors")} *</Form.Label>
            <Form.Control
              type="text"
              name="organizationType.visitors"
              value={form.organizationType.visitors}
              onChange={handleLetterChange}
              inputMode="numeric"
              isInvalid={!!errors.webVisitors}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("validation.field")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formCop29Section" className="mt-3">
            <Form.Label>{t("personalInformation.cop29Section")} *</Form.Label>
            <Form.Control className="form-select"
              as="select"
              name="organizationType.COP29"
              value={form.organizationType.COP29}
              onChange={handleLetterChange}
              isInvalid={!!errors.COP29}
              required
            >
              <option value="">{t("choose")}</option>
              <option value={true}>{t("yes")}</option>
              <option value={false}>{t("no")}</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {t("validation.field")}
            </Form.Control.Feedback>
          </Form.Group>

          {form.organizationType.COP29 === "true" && (
            <Form.Group controlId="formUrl" className="mt-3">
              <Form.Label>{t("personalInformation.url")} *</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("personalInformation.url")}
                name="organizationType.url"
                value={form.organizationType.url}
                onChange={handleLetterChange}
                required
              />
            </Form.Group>
          )}
        </>
      )}

      {(form.mediaType !== "TV" && form.mediaType !== "RADIO" && form.mediaType !== "WEBSITE") && (
        <>
          <Form.Group controlId="formPublicationName" className="mt-3">
            <Form.Label>{t("personalInformation.publicationName")} *</Form.Label>
            <Form.Control
              type="text"
              name="organizationType.name"
              value={form.organizationType.name}
              onChange={handleChange}
              isInvalid={!!errors.publicationName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("validation.field")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formFrequency" className="mt-3">
            <Form.Label>{t("personalInformation.frequency")} *</Form.Label>
            <Form.Control
              as="select" className="form-select"
              name="organizationType.frequency"
              value={form.organizationType.frequency}
              onChange={handleLetterChange}
              required
              isInvalid={!!errors.frequency}
            >
              <option value="">{t("choose")}</option>
              <option value="DAILY">{t("personalInformation.frequencyOptions.DAILY")}</option>
              <option value="WEEKLY">{t("personalInformation.frequencyOptions.WEEKLY")}</option>
              <option value="MONTHLY">{t("personalInformation.frequencyOptions.MONTHLY")}</option>
              <option value="OTHER">{t("personalInformation.frequencyOptions.OTHER")}</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {t("validation.field")}
            </Form.Control.Feedback>
          </Form.Group>

          {form.organizationType.frequency === "OTHER" && (
            <Form.Group controlId="formFrequencyOther" className="mt-3">
              <Form.Label>{t("personalInformation.frequencyOther")} *</Form.Label>
              <Form.Control
                type="text"
                name="organizationType.otherFrequency"
                value={form.organizationType.otherFrequency}
                onChange={handleChange}
                isInvalid={!!errors.otherFrequency}
                required
              />
              <Form.Control.Feedback type="invalid">
                {t("validation.field")}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          <Form.Group controlId="formCirculation" className="mt-3">
            <Form.Label>{t("personalInformation.circulation")} *</Form.Label>
            <Form.Control
              type="text"
              name="organizationType.circulationVisitors"
              value={form.organizationType.circulationVisitors}
              inputMode="numeric"
              onChange={handleNumberChange}
              isInvalid={!!errors.circulation}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("validation.circulation")}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}
      <Form.Group
        controlId="formOrganizationComments"
        className="mt-3"
      >
        <Form.Label>
          {t("personalInformation.organizationComments")}
        </Form.Label>
        <Form.Control
          type="text"
          name="organization.additionalComments"
          value={form.organization.additionalComments}
          onChange={handleLetterChange}
          required
        />
      </Form.Group>

      
    </>
  );
};

export default OrganizationDetails;
